// Negotiate document scrolling only with a parent that can resize this preview.
// Older admin pages keep the existing independently scrolling iframe.
export function connectPreviewLayout() {
  if (window.parent === window) return;
  const origin = import.meta.env.VITE_ADMIN_ORIGIN || 'https://hireaigo.com';
  const nonce = crypto.randomUUID();
  let observer, mutations, scheduled = 0, lastHeight = 0, connected = false;
  const send = () => {
    scheduled = 0;
    const root = document.getElementById('root');
    const height = Math.ceil(Math.max(600, root?.getBoundingClientRect().height || 0));
    if (height !== lastHeight && height <= 60000) {
      lastHeight = height;
      window.parent.postMessage({type:'aigo-owner-height', nonce, height}, origin);
    }
  };
  const measure = () => { if (!scheduled) scheduled = setTimeout(send, 16); };
  const receive = e => {
    if (connected || e.source !== window.parent || e.origin !== origin || e.data?.type !== 'aigo-owner-layout' || e.data?.nonce !== nonce) return;
    connected = true;
    clearInterval(retry); clearTimeout(timeout);
    document.documentElement.classList.add('owner-preview-document');
    observer = new ResizeObserver(measure);
    observer.observe(document.getElementById('root'));
    mutations = new MutationObserver(measure);
    mutations.observe(document.getElementById('root'), {childList:true,subtree:true,characterData:true});
    window.addEventListener('resize', measure);
    measure();
  };
  const ready = () => window.parent.postMessage({type:'aigo-owner-layout-ready', nonce}, origin);
  window.addEventListener('message', receive);
  const retry = setInterval(ready, 1000), timeout = setTimeout(() => clearInterval(retry), 15000);
  ready();
  return () => {
    clearInterval(retry); clearTimeout(timeout); clearTimeout(scheduled);
    observer?.disconnect(); mutations?.disconnect(); window.removeEventListener('resize', measure); window.removeEventListener('message', receive);
    document.documentElement.classList.remove('owner-preview-document');
  };
}
